import styled from "styled-components";

export const StyledPagesInventoryArchiverUi = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  height: 100%;
  margin: 10px;
`;

export const StyledPageHeader = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  margin-top: 0px;
`;
